// wxPay/WxPayOrderEdit.tsx
import WxPayOrderEditBase from './WxPayOrderEditBase';

const WxPayOrderEdit = (props: any) => (
    <WxPayOrderEditBase apiId="wxPayOrder" outerProps={props} />
);

export default WxPayOrderEdit;